module.exports = __webpack_public_path__ + "img/de.9441aa0f.png";